<template>
  <div class="mx-md-12 px-sm-12 text-center">
    <p class="display-1 primary--text text-center">Die Geschichte</p>

    <p align="justify">
      Im Jahre 1966 hat die Marktgemeinde Frankenburg am Hausruck von den Ordensschwestern das „Versorgungsheim", auch als „Armenhaus” bekannt, übernommen. Von 1966 bis 1985 standen uns 27 Heimplätze zur Verfügung.
    </p>

    <img width="250" max-width="50%" :src="require('@/assets/Ueber_Uns/Die_Geschichte/versorgungsheim.jpg')"/>

    <p align="justify">
      Nach dem Grundsatzbeschluss, ein neues Altenheim zu errichten, wurde am Jänner 1977 das neue Grundstück gekauft. Mit 61 Betten ausgestattet wurde das Heim im April 1985 bezogen und kurz darauf voll belegt.
    </p>

    <img width="500" max-width="100%" :src="require('@/assets/Ueber_Uns/Die_Geschichte/altes_heim.jpg')"/>

    <p align="justify">
      Bei Inbetriebnahme war ein Großteil der Bewohner noch mobil. Da neue Heimbewohner in immer schlechterem Allgemeinzustand ins Altenheim kamen, wurde der Pflegebedarf immer größer und das Haus konnte die Anforderungen der pflegegerechten Bauweise nicht mehr erfüllen. Aus diesem Grund kam der Gemeinderat zu dem Beschluss das Haus um- und auszubauen.
      Als Überbrückung dieser Zeit residierten die Bewohner in einem Wohndorf.
    </p>

    <img width="500" max-width="100%" :src="require('@/assets/Ueber_Uns/Die_Geschichte/wohndorf.jpg')"/>

    <p align="justify">
      Nach der Fertigstellung im August 2006 übersiedelten die Bewohner in das neu ausgebaute Altenheim.
    </p>
  
    <img width="500" max-width="100%" :src="require('@/assets/Ueber_Uns/Die_Geschichte/heim.jpg')"/>

    
  </div>
</template>


<script>
  export default {
    name: 'unser_haus',
  }
</script>